import { Image, LI } from "../../../../AbstractElements";
import { GROUPING_SECOND } from "../../../../Data/UiKit/Avatars";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const GroupingSecond = () => {
  return (
    <div className="customers d-inline-block avatar-group">
      <ul className="simple-list">
        <LI className="d-inline-block">
          <Image className="img-60 rounded-circle" src={dynamicImage("avtar/16.jpg")} alt="image" />
        </LI>
        {GROUPING_SECOND.map(({ className1, className2, src }, index) => (
          <LI className="d-inline-block" key={index}>
            <Image className={`${className1 && className1} ${className2 && className2} h-auto`} src={src} alt="image" />
          </LI>
        ))}
      </ul>
    </div>
  );
};
